import React from 'react';
import PropTypes from 'prop-types'; // eslint-disable-line import/no-extraneous-dependencies
import { renderList } from '../../helpers/arrayHelpers';
import InputTitle from './InputTitle';

const Option = ({ text, index, firstOptionHasValue }) => {
  if (!firstOptionHasValue) {
    return <option value={index === 0 ? '' : index}>{text}</option>;
  } else {
    return <option value={index}>{text}</option>;
  }
}

const Options = ({ dataSet = [], firstOptionHasValue = false }) =>
  renderList(dataSet, ({ item, index, key }) =>
    <Option text={item} key={key} id={key} value={item} index={index} firstOptionHasValue={firstOptionHasValue} />);

const Select = ({
  onChange, options = [], name, value, labelTitle, required, firstOptionHasValue
}) => {
  const handleOnChange = (e) => onChange(e.target);

  return (
    <div className="select">
      <label>
        <InputTitle>{labelTitle}</InputTitle>
        <select value={value} name={name} onChange={handleOnChange} required={required}>
          <Options
            dataSet={options}
            firstOptionHasValue={firstOptionHasValue}
          />
        </select>
        <div className="select-arrow" />
      </label>
    </div>
  );
};

Select.propTypes = {
  labelTitle: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

Select.defaultProps = {
  labelTitle: '',
  name: '',
  onChange: () => { },
  value: '',
};
export default Select;
